import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout";
import NotAuthorized from "./pages/NotAuthorized";
import PageNotFound from "./pages/PageNotFound";
import { Backdrop, CircularProgress } from "@mui/material";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import Login from "./pages/Login";
import Register from "./pages/Register";
import OTP from "./pages/OTP";
import ForgotPassword from "./pages/ForgotPassword";

function App() {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const backdrop = (
    <Backdrop
      sx={{ color: "#fff", zIndex: 2000 }}
      open={!!isFetching || !!isMutating}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
  return (
    <>
      {backdrop}
      <Routes>
        <Route path="/notAuthorized" element={<NotAuthorized />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/login" replace />} />
          <Route path="register" element={<Register />} />
          <Route path="otp" element={<OTP />} />
          <Route path="forgotPassword" element={<ForgotPassword />} />
          <Route path="login" element={<Login />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}
export default App;
